import { consoleLogger } from '../logging/consoleLogger';

export const encodeToBase64 = (value) => {
  try {
    return btoa(value);
  } catch (err) {
    if (err instanceof DOMException && err.name === 'InvalidCharacterError') {
      consoleLogger.logError(
        `The value ${value} contained a character that could not be encoded`,
      );
      throw err;
    } else {
      consoleLogger.logError(`An error occured when decoding "${value}"`);
      throw err;
    }
  }
};
